// tickets to park
export const TICKETS_TO_PARK_LIMIT = 25

// upsells
export const BUS_TICKETS_LIMIT = 44
export const CABANAS_LIMIT = 12
export const PHOTOS_PER_PACKAGE_LIMIT = 10

// accommodation
export const BUNGALOW_ADULTS_MIN_LIMIT = 1
export const BUNGALOW_ADULTS_MAX_LIMIT = 8

// vouchers
export const VALUE_VOUCHERS_LIMIT = 14
export const CARD_VOUCHERS_LIMIT = 9
